import { useEffect } from 'react'

import { Flex, FlexProps } from '@chakra-ui/react'
import _ from 'lodash'

import { HIGHLIGHT_ANIMATION_DURATION_MS } from 'src/lib/constants'
import { getColorHexValue } from 'src/lib/utils'
import { BrandColor } from 'src/types'

import useCardWrapper from './useCardWrapper'

const CardWrapper: React.ForwardRefRenderFunction<
  HTMLDivElement,
  {
    children: React.ReactNode
    brandColor: BrandColor
    offScreenRender?: React.ReactNode
    itemId: number
  } & FlexProps
> = ({ children, brandColor, itemId, offScreenRender, ...props }) => {
  const { isVisible, shouldHighlight, scope, animate } = useCardWrapper(itemId)
  useEffect(() => {
    if (shouldHighlight) {
      animate(
        scope.current,
        {
          backgroundColor: [`${getColorHexValue(brandColor)}19`, '#ffffffff'],
        },
        {
          duration: HIGHLIGHT_ANIMATION_DURATION_MS / 1000,
        }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldHighlight])

  return (
    <Flex
      direction="column"
      borderRadius={12}
      boxShadow="md"
      overflow="clip"
      ref={scope}
      {...props}
    >
      {!isVisible && offScreenRender ? offScreenRender : children}
    </Flex>
  )
}

export default CardWrapper
